import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./shell.css";

type Props = {
    collapsed: boolean;
    onToggle: () => void;
};

type RailItem = {
    key: string;
    label: string;
    icon: React.ReactNode;
    path: string;
};

const items: RailItem[] = [
    { key: "all", label: "Dashboard", icon: "🏠", path: "/Dashboard" },
    { key: "ct", label: "Tuyển sinh", icon: "🟦", path: "/danh-sach-thi-sinh" },
    { key: "xet", label: "Lớp", icon: "🗓️", path: "/danh-sach-lop" },
    { key: "th", label: "Điểm", icon: "📄", path: "/nhap-diem-theo-lop" },
    { key: "ht", label: "Thiết lập", icon: "🖥️", path: "/thiet-lap-nganh" },
];

export default function Rail({ collapsed, onToggle }: Props) {
    const nav = useNavigate();
    const { pathname } = useLocation();

    return (
        <div className="rail">
            <button className="railHamburger" onClick={onToggle} title="Thu gọn / Mở rộng">
                ☰
            </button>

            {items.map((it) => {
                const active = pathname === it.path || pathname.startsWith(it.path + "/");
                return (
                    <div key={it.key} className="railItemWrap">
                        <button
                            className={"railBtn" + (active ? " railBtnActive" : "")}
                            onClick={() => nav(it.path)}
                            title={it.label}
                        >
                            <span className="railIcon">{it.icon}</span>
                        </button>
                        <div className="railLabel">{it.label}</div>
                    </div>
                );
            })}

            <div style={{ flex: 1 }} />

            <button className="railBtn" title="Tài khoản">
                <span className="railIcon">👤</span>
            </button>
        </div>
    );
}
